export default "__VITE_ASSET__B8kIo_0A__"